import React, { useEffect } from "react"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"
import api from "services/api.service"
import { userService } from "services/user.service"

const ActionItemsOptions = ({
  scenario,
  scenarioId,
  selectedAlternativeList,
  selectedAlternatives,
  toggleSearchModal,
  toggleChatGptDrawer,
  toggleConfigModal,
  toggleCreateListModal,
  toggleReportModal,
  toggleUploadAlternativesModal,
  toggleHealthModal,
  toggleIntakeModal,
  toggleViewListsModal,
  toggleLocationsModal,
  toggleRoadmapModal,
  exportTable,
  showSelectionAlert,
  props,
}) => {
  const currentUser = userService.getLoggedInUser()
  const [showActionsDropdown, setShowActionsDropdown] = React.useState(false)
  const [scenarioActionItems, setScenarioActionItems] = React.useState([])

  useEffect(() => {
    loadActionItems()
  }, [])

  const loadActionItems = async () => {
    let scenarioActionItems = await api.getUserActionRights(
      scenarioId,
      "ListActions"
    )
    setScenarioActionItems(scenarioActionItems)
    console.log("ListActions:", scenarioActionItems)
  }

  const hasActionItem = actionItemName => {
    return scenarioActionItems.some(item => item.actionItem === actionItemName)
  }

  return (
    <Dropdown
      direction="start"
      className="save-user"
      isOpen={showActionsDropdown}
      toggle={() => setShowActionsDropdown(!showActionsDropdown)}
    >
      <DropdownToggle tag="button" className="btn btn-outline-primary">
        Actions <i className="mdi mdi-chevron-down" />
      </DropdownToggle>
      <DropdownMenu style={{ maxHeight: "500px", overflowX: "auto" }}>
        <DropdownItem
          onClick={() => {
            toggleSearchModal()
          }}
        >
          <i className="fas fa-search"></i> Advanced Search
        </DropdownItem>

        {scenarioId > 0 && currentUser.useAI && (
          <DropdownItem
            className="always-enabled"
            onClick={toggleChatGptDrawer}
          >
            {scenario != null && (
              <div>
                <i className="mdi mdi-brain" /> Ask AI for{" "}
                {scenario.alternativeName}
              </div>
            )}
          </DropdownItem>
        )}

        {scenarioId > 0 && hasActionItem("BatchEdit") && (
          <DropdownItem
            onClick={() => {
              props.history.push(`/editProjects/${scenarioId}`)
            }}
          >
            <i className="fas fa-edit"></i> Batch Edit
          </DropdownItem>
        )}

        {selectedAlternativeList == null && (
          <DropdownItem
            onClick={() => {
              toggleConfigModal()
            }}
          >
            <i className="fas fa-cog"></i> Configure View
          </DropdownItem>
        )}

        {scenarioId > 0 && hasActionItem("CreateFilteredList") && (
          <DropdownItem
            onClick={() => {
              toggleCreateListModal()
            }}
          >
            <i className="far fa-list-alt"></i> Create Filtered List
          </DropdownItem>
        )}

        {hasActionItem("DownloadBCReports") && (
          <DropdownItem
            onClick={() => {
              let selected = [...selectedAlternatives]
              if (selected.length > 30) {
                swalWithConfirmButton.fire({
                  title: `You must select 30 or less items.`,
                  icon: "warning",
                  showCancelButton: false,
                  confirmButtonText: "Ok",
                })
              } else if (selected.length > 0) {
                toggleReportModal()
              } else {
                showSelectionAlert()
              }
            }}
          >
            <i className="mdi mdi-folder-zip"> </i>Download Business Case
            Reports
          </DropdownItem>
        )}

        <DropdownItem
          onClick={() => {
            exportTable()
          }}
        >
          <i className="fas fa-table"></i> Export Table
        </DropdownItem>

        {scenarioId > 0 && hasActionItem("UploadBusinessCases") && (
          <DropdownItem
            onClick={() => {
              toggleUploadAlternativesModal()
            }}
          >
            <i className="fas fa-cloud-upload-alt"></i> Upload{" "}
            {scenario && scenario.alternativeName}s
          </DropdownItem>
        )}

        {scenarioId != 0 && hasActionItem("HealthTimelineDashboard") && (
          <DropdownItem
            onClick={() => {
              let selected = [...selectedAlternatives]
              if (selected.length > 0) {
                toggleHealthModal()
              } else {
                showSelectionAlert()
              }
            }}
          >
            <i className="fas fa-chart-pie"></i> View Health and Timeline
          </DropdownItem>
        )}

        {scenarioId != 0 && hasActionItem("IntakeFinancialsDashboard") && (
          <DropdownItem
            onClick={() => {
              let selected = [...selectedAlternatives]
              if (selected.length > 0) {
                toggleIntakeModal()
              } else {
                showSelectionAlert()
              }
            }}
          >
            <i className="fas fa-funnel-dollar"></i> View Intake and Financials
          </DropdownItem>
        )}

        {scenarioId != 0 && (
          <DropdownItem
            onClick={() => {
              toggleViewListsModal()
            }}
          >
            <i className="far fa-list-alt"></i> View Lists
          </DropdownItem>
        )}

        {hasActionItem("ViewMap") && (
          <DropdownItem
            onClick={() => {
              let selected = [...selectedAlternatives]
              if (selected.length > 0) {
                toggleLocationsModal()
              } else {
                showSelectionAlert()
              }
            }}
          >
            <i className="fas fa-map-marked-alt"></i> View Map
          </DropdownItem>
        )}

        {scenarioId > 0 && hasActionItem("ViewResourcePlans") && (
          <DropdownItem
            onClick={() => {
              props.history.push(`/ResourcePlanning/${scenarioId}`)
            }}
          >
            <i className="fas fa-people-arrows"></i> View Resource Plans
          </DropdownItem>
        )}

        {scenarioId != 0 && hasActionItem("ViewRoadmap") && (
          <DropdownItem
            onClick={() => {
              let selected = [...selectedAlternatives]
              if (selected.length > 0) {
                toggleRoadmapModal()
              } else {
                showSelectionAlert()
              }
            }}
          >
            <i className="fas fa-road"></i> View Roadmap
          </DropdownItem>
        )}
      </DropdownMenu>
    </Dropdown>
  )
}

export default ActionItemsOptions
